import { Link } from "react-router-dom";
import { AnimBounceInBottom } from '@readdy/anim/card/bounce-in-bottom/react';
import { stats } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 vx-grid-bg pointer-events-none" />
      <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-primary-100/70 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full bg-accent-100/70 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
              Wholesale VoIP · Voice Termination · DID · SIP Trunking
            </div>

            <h1 className="vx-reveal font-heading text-4xl md:text-6xl lg:text-7xl font-semibold text-foreground-950 leading-[1.05] tracking-tight">
              Carrier-grade voice,
              <br />
              <span className="text-primary-600">delivered globally.</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-700 max-w-2xl leading-relaxed">
              Voxmaster LLC is a wholesale VoIP carrier providing high-quality voice termination, DID origination and SIP trunking to operators, resellers, call centers and CPaaS platforms. Direct interconnects, transparent pricing, and a real human NOC — 24/7.
            </p>

            <div className="vx-reveal vx-reveal-delay-1 mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
              >
                Get a custom quote
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
              <Link
                to="/coverage"
                className="inline-flex items-center justify-center gap-2 bg-background-50 border border-background-300 hover:border-accent-500 hover:text-accent-700 text-foreground-800 px-6 py-3.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-file-download-line w-4 h-4 flex items-center justify-center" />
                Download rate deck
              </Link>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-600" />
                Direct Tier-1 & Tier-2 interconnects
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center text-accent-600" />
                Live in as little as 48 hours
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-earth-line w-4 h-4 flex items-center justify-center text-accent-600" />
                1000+ destinations covered
              </span>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 via-accent-200/40 to-transparent rounded-2xl blur-2xl" />
              <AnimBounceInBottom duration={800}>
                <div className="relative bg-background-50 border border-background-200 rounded-2xl p-3">
                  <video
                    className="w-full rounded-xl"
                    src="https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/2aeefc6c-57cb-4fbe-bf2a-803d308c922f_generated_video.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    controls
                  />
                </div>
              </AnimBounceInBottom>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="text-2xl md:text-3xl font-semibold font-heading text-foreground-950">{s.value}</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}